import React from 'react';

import RefreshIcon from '@mui/icons-material/Refresh';
import { FormattedMessage } from 'react-intl';

import { RefreshIconContainer } from './NewAppBanner.style';
import { StyledBanner, StyledCloseIcon } from '../Banners.style';

interface Props {
  waitingServiceWorker: ServiceWorker;
  setIsBannerVisible: (isBannerVisible: boolean) => void;
  className?: string;
}

const NewAppBanner: React.FC<Props> = ({ waitingServiceWorker, setIsBannerVisible, className }) => {
  const onReloadClick = () => {
    waitingServiceWorker.postMessage({ type: 'SKIP_WAITING' });
    window.location.reload();
  };

  const onCloseClick = () => {
    setIsBannerVisible(false);
  };

  return (
    <StyledBanner className={className}>
      <div className='banner-container'>
        <div className='banner-content'>
          <FormattedMessage id='home.app-update.message' />
        </div>
        <div className='banner-button-wrapper'>
          <RefreshIconContainer>
            <RefreshIcon onClick={onReloadClick} fontSize='inherit' />
          </RefreshIconContainer>
          <StyledCloseIcon onClick={onCloseClick} />
        </div>
      </div>
    </StyledBanner>
  );
};

export default NewAppBanner;
